import _regeneratorRuntime from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { WebCryptoAlgorithmSuite, KeyringWebCrypto, WebCryptoDefaultCryptographicMaterialsManager, getDecryptionHelper, needs, CommitmentPolicy, CommitmentPolicySuites } from '@aws-crypto/material-management-browser';
import { deserializeSignature, deserializeFactory, decodeBodyHeader, aadFactory, concatBuffers, der2raw } from '@aws-crypto/serialize';
import { fromUtf8, toUtf8 } from '@aws-sdk/util-utf8-browser';
var deserialize = deserializeFactory(toUtf8, WebCryptoAlgorithmSuite);

var _aadFactory = aadFactory(fromUtf8),
    messageAADContentString = _aadFactory.messageAADContentString,
    messageAAD = _aadFactory.messageAAD;

export function _decrypt(_x, _x2, _x3) {
  return _decrypt2.apply(this, arguments);
}

function _decrypt2() {
  _decrypt2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(commitmentPolicy, cmm, ciphertext) {
    var headerInfo, messageHeader, algorithmSuite, rawHeader, headerAuth, headerIv, headerAuthTag, encryptionContext, encryptedDataKeys, suiteId, messageId, messageIdStr, suite, material, _yield$getDecryptionH, getDecryptInfo, subtleVerify, dispose, getSubtleDecrypt, _yield$bodyDecrypt, plaintext, readPos, data, signatureInfo, derSignature, rawSignature, isValid;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            /* Precondition: _decrypt needs a valid commitmentPolicy. */
            needs(CommitmentPolicy[commitmentPolicy], 'Invalid commitment policy.');
            /* If the cmm is a Keyring, wrap it with WebCryptoDefaultCryptographicMaterialsManager. */

            cmm = cmm instanceof KeyringWebCrypto ? new WebCryptoDefaultCryptographicMaterialsManager(cmm) : cmm;
            headerInfo = deserialize.deserializeMessageHeader(ciphertext);

            if (!(headerInfo === false)) {
              _context.next = 5;
              break;
            }

            throw new Error('Unable to parse Header');

          case 5:
            messageHeader = headerInfo.messageHeader, algorithmSuite = headerInfo.algorithmSuite;
            rawHeader = headerInfo.rawHeader, headerAuth = headerInfo.headerAuth;
            headerIv = headerAuth.headerIv, headerAuthTag = headerAuth.headerAuthTag;
            encryptionContext = messageHeader.encryptionContext, encryptedDataKeys = messageHeader.encryptedDataKeys, suiteId = messageHeader.suiteId, messageId = messageHeader.messageId; // Very quick hex string

            messageIdStr = _toConsumableArray(messageId).map(function (i) {
              return i > 15 ? i.toString(16) : '0' + i.toString(16);
            }).join('');
            /* Precondition: The parsed header algorithmSuite in _decrypt must be supported by the commitmentPolicy. */

            CommitmentPolicySuites.isDecryptEnabled(commitmentPolicy, algorithmSuite, messageIdStr);
            suite = new WebCryptoAlgorithmSuite(suiteId);
            _context.next = 14;
            return cmm.decryptMaterials({
              suite: suite,
              encryptionContext: encryptionContext,
              encryptedDataKeys: encryptedDataKeys
            });

          case 14:
            material = _context.sent;

            /* Precondition: The material algorithmSuite returned to _decrypt must be supported by the commitmentPolicy. */
            CommitmentPolicySuites.isDecryptEnabled(commitmentPolicy, material.suite, messageIdStr);
            _context.next = 18;
            return getDecryptionHelper(material);

          case 18:
            _yield$getDecryptionH = _context.sent;
            getDecryptInfo = _yield$getDecryptionH.getDecryptInfo;
            subtleVerify = _yield$getDecryptionH.subtleVerify;
            dispose = _yield$getDecryptionH.dispose;
            _context.next = 24;
            return getDecryptInfo(messageId, messageHeader.suiteData);

          case 24:
            getSubtleDecrypt = _context.sent;
            _context.next = 27;
            return getSubtleDecrypt(headerIv, rawHeader)(headerAuthTag);

          case 27:
            _context.next = 29;
            return bodyDecrypt({
              buffer: ciphertext,
              getSubtleDecrypt: getSubtleDecrypt,
              headerInfo: headerInfo
            });

          case 29:
            _yield$bodyDecrypt = _context.sent;
            plaintext = _yield$bodyDecrypt.plaintext;
            readPos = _yield$bodyDecrypt.readPos;
            dispose();

            if (!subtleVerify) {
              _context.next = 45;
              break;
            }

            data = ciphertext.slice(0, readPos);
            signatureInfo = ciphertext.slice(readPos);
            derSignature = deserializeSignature(signatureInfo);
            rawSignature = der2raw(derSignature, material.suite);
            _context.next = 40;
            return subtleVerify(rawSignature, data);

          case 40:
            isValid = _context.sent;

            /* Postcondition: subtleVerify must validate the signature. */
            needs(isValid, 'Invalid Signature');
            return _context.abrupt("return", {
              messageHeader: messageHeader,
              plaintext: plaintext
            });

          case 45:
            return _context.abrupt("return", {
              messageHeader: messageHeader,
              plaintext: plaintext
            });

          case 46:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _decrypt2.apply(this, arguments);
}

function bodyDecrypt(_x4) {
  return _bodyDecrypt.apply(this, arguments);
}
/* As we move to deprecate non-framed encrypt it is important to continue to support
 * non-framed decrypt.  The names not-withstanding, this supports non-framed decrypt
 * See decodeBodyHeader (it abstracts framed and non-framed body headers)
 */


function _bodyDecrypt() {
  _bodyDecrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var buffer, getSubtleDecrypt, headerInfo, readPos, clearBuffers, sequenceNumber, _yield$framedDecrypt, clearBlob, frameInfo, plaintext;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            buffer = _ref.buffer, getSubtleDecrypt = _ref.getSubtleDecrypt, headerInfo = _ref.headerInfo;
            readPos = headerInfo.rawHeader.byteLength + headerInfo.headerAuth.headerAuthLength;
            clearBuffers = [];
            sequenceNumber = 0; // This is unfortunate, ideally the eslint no-constant-condition could be resolve
            // but at this time, I'm just going to disable this line
            // and leave a note to keep myself from replicating this kind of logic.

            /* eslint-disable no-constant-condition */

          case 4:
            if (!true) {
              _context2.next = 19;
              break;
            }

            /* eslint-enable no-constant-condition */

            /* Keeping track of the sequence number myself. */
            sequenceNumber += 1;
            _context2.next = 8;
            return framedDecrypt({
              buffer: buffer,
              getSubtleDecrypt: getSubtleDecrypt,
              headerInfo: headerInfo,
              readPos: readPos
            });

          case 8:
            _yield$framedDecrypt = _context2.sent;
            clearBlob = _yield$framedDecrypt.clearBlob;
            frameInfo = _yield$framedDecrypt.frameInfo;

            /* Precondition: The sequenceNumber is required to monotonically increase, starting from 1.
             * This is to avoid a bad actor from abusing the sequence number on un-signed algorithm suites.
             * If the frame size matched the data format (say NDJSON),
             * then the data could be significantly altered just by rearranging the frames.
             * Non-framed data returns a sequenceNumber of 1.
             */
            needs(frameInfo.sequenceNumber === sequenceNumber, 'Encrypted body sequence out of order.');
            clearBuffers.push(clearBlob);
            readPos = frameInfo.readPos;

            if (!frameInfo.isFinalFrame) {
              _context2.next = 17;
              break;
            }

            plaintext = concatBuffers.apply(void 0, clearBuffers);
            return _context2.abrupt("return", {
              plaintext: plaintext,
              readPos: readPos
            });

          case 17:
            _context2.next = 4;
            break;

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _bodyDecrypt.apply(this, arguments);
}

function framedDecrypt(_x5) {
  return _framedDecrypt.apply(this, arguments);
}

function _framedDecrypt() {
  _framedDecrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
    var buffer, getSubtleDecrypt, headerInfo, readPos, messageId, frameInfo, cipherLength, contentString, messageAdditionalData, cipherBlob, clearBlob;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            buffer = _ref2.buffer, getSubtleDecrypt = _ref2.getSubtleDecrypt, headerInfo = _ref2.headerInfo, readPos = _ref2.readPos;
            messageId = headerInfo.messageHeader.messageId;
            frameInfo = decodeBodyHeader(buffer, headerInfo, readPos);

            if (frameInfo) {
              _context3.next = 5;
              break;
            }

            throw new Error('Format Error');

          case 5:
            cipherLength = frameInfo.contentLength + frameInfo.tagLength / 8;
            contentString = messageAADContentString(frameInfo);
            messageAdditionalData = messageAAD(messageId, contentString, frameInfo.sequenceNumber, frameInfo.contentLength);
            cipherBlob = buffer.slice(frameInfo.readPos, frameInfo.readPos + cipherLength);
            _context3.next = 11;
            return getSubtleDecrypt(frameInfo.iv, messageAdditionalData)(cipherBlob);

          case 11:
            clearBlob = _context3.sent;
            frameInfo.readPos += cipherLength;
            return _context3.abrupt("return", {
              clearBlob: clearBlob,
              frameInfo: frameInfo
            });

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _framedDecrypt.apply(this, arguments);
}